/**
 * Páginas públicas que sirve job-apply-service en jobs.tbit.app (HTML del
 * servidor, no la SPA): se enlazan con <a>, no con <Link>.
 */

/** La guía del puntaje de la hoja de vida (`SCORE_GUIDE_SLUG` en job-apply-service). */
export const SCORE_GUIDE_PATH = '/empleos/guias/como-funciona-el-puntaje-de-tu-hoja-de-vida';
export const TERMS_URL = 'https://tbit.app/es/legal/tbit-jobs-terminos-y-condiciones';
export const PRIVACY_URL = 'https://tbit.app/es/legal/politica-de-privacidad';
